import { gql } from "@apollo/client";

const GET_REMITTANCE_ITEM_COUNT = gql`
  query RemittanceItemCount($params: GetRemittanceItemCountParams!) {
    remittanceItemCount(
        params: $params
    ) {
        all
        incomplete
        stages {
            stageId
            count
        }
    }
}
`;

export default GET_REMITTANCE_ITEM_COUNT;